import "./ReportTableView.scss";
import { useSelector } from "react-redux";
import { TableFiltersData } from "./TableFiltersData/TableFiltersData";
import { TableViewData } from "./TableViewData/TableViewData";
import { RootState } from "../../../store/reducers";

export const ReportTableView = () => {
  const { isToggleTableView } = useSelector(
    (state: RootState) => state.jobPricingDetails
  );
  return (
    <div className="sjpr-table-view-container">
      {isToggleTableView && (
        <>
          <TableFiltersData />
          <TableViewData />
        </>
      )}
    </div>
  );
};
